import React, { createContext, useState, useContext, useEffect, useMemo } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useParams } from "react-router-dom";
import { Header } from "../../header/Header";
import { PageHeader } from "../../header/PageHeader";

// Create a Context
const ApplicationContext = createContext<IApplicationContext>({
  id: "",
  application: {},
  applicationBase: {},
  rehydrate: async () => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setApplication: (application: any) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setHeaderText: (headerText: IHeadetText) => {},
});

// Create a provider component
export const ApplicationContextProvider = ({ children }: any) => {
  const [application, setApplication] = useState<any>({});
  const { fetchData } = useApiClient("Application");
  const [loaded, setLoaded] = useState(false);
  const { id } = useParams<{ id: string }>();

  const [headerText, setHeaderText] = useState<IHeadetText>({
    value: "Edit Type of Application",
    icon: "view-app-icon mr-3 mt-0",
  });

  useEffect(() => {
    getApplication(id ?? "");
  }, [id]);

  function rehydrate(): Promise<void | never> {
    return getApplication(id ?? "");
  }

  function getApplication(id: string): Promise<void | never> {
    return fetchData(id).then((res) => {
      setApplication(res.data), setLoaded(true);
    });
  }

  const childInfo = useMemo(() => {
    if (application.applicationBase == null) return {};
    const { child, kindergarten } = application.applicationBase;

    return {
      name: `${child.firstName} ${child.lastName}`.trim(),
      kinder: kindergarten.fundedKinder.accountName == "Other" ? kindergarten.kindergartenNameOther : kindergarten.fundedKinder.accountName,
    };
  }, [application]);

  return (
    <ApplicationContext.Provider
      value={{
        id: id ?? "",
        application,
        applicationBase: application.applicationBase,
        rehydrate,
        setApplication,
        setHeaderText,
      }}>
      <Header />
      <PageHeader headerText={[headerText]} icon={"icon"}>
        <div className="student-info">
          {loaded && (
            <>
              <span className="stu-details-icon"></span> <span className="mr-1">Application for:</span> <b>{childInfo?.name}</b>{" "}
              <span className="mx-1">at kindergarten</span>
              <b>{childInfo?.kinder}</b>, <span className="mx-1">Reference ID:</span> <b>{id}</b>
            </>
          )}
        </div>
      </PageHeader>
      {loaded && children}
    </ApplicationContext.Provider>
  );
};

interface IApplicationContext {
  id: string;
  application: any;
  applicationBase: any;
  rehydrate: () => Promise<void | never>;
  setApplication: (application: any) => void;
  setHeaderText: (headerText: IHeadetText) => void;
}

interface IHeadetText {
  value: string;
  icon: string;
  class?: string;
}
// Custom hook for using the context
export const useApplicationContext = (): IApplicationContext => useContext(ApplicationContext);
